import {
  Bird,
  Calendar,
  List,
  Mail,
  Users,
  Home,
  type LucideIcon,
} from "lucide-react"

import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar"
import {
  Collapsible,
  CollapsibleTrigger,
  CollapsibleContent,
} from "@/components/ui/collapsible"
import { ChevronDown } from "lucide-react"
import { type CurrentUserOrg } from "@/types/index"
import { useUser } from "@/contexts/UserContext"

export interface OrgNavLink {
  name: string;
  url: string;
  icon: LucideIcon;
  adminFunction?: boolean;
}

export function NavOrgs() {
  const { currentUser: { organisations } } = useUser()

  return (
    <div className="flex flex-col gap-2">
      {organisations.map((org) => (
        <NavOrg key={org.orgId} org={org} />
      ))}
    </div>
  )
}


import { useState } from "react"

export function NavOrg({ org }: { org: CurrentUserOrg }) {
  const links: OrgNavLink[] = [
    {
      name: "Home",
      url: `/app/org/${org.orgId}`,
      icon: Home,
      adminFunction: false
    },
    {
      name: "Users",
      url: `/app/org/${org.orgId}/users`,
      icon: Users,
      adminFunction: true
    },
    {
      name: "Records",
      url: `/app/org/${org.orgId}/records`,
      icon: List,
      adminFunction: false
    },
    {
      name: "Species",
      url: `/app/org/${org.orgId}/species`,
      icon: Bird,
      adminFunction: false
    },
    {
      name: "Messages",
      url: `/app/org/${org.orgId}/messages`,
      icon: Mail,
      adminFunction: true
    },
    {
      name: "Events",
      url: `/app/org/${org.orgId}/events`,
      icon: Calendar,
      adminFunction: false
    },
  ]

  const [open, setOpen] = useState(true)

  return (
    <Collapsible className="w-full" open={open} onOpenChange={setOpen}>
      <SidebarGroup className="group-data-[collapsible=icon]:hidden">
        <CollapsibleTrigger asChild>
          <SidebarGroupLabel className="flex cursor-pointer items-center justify-between gap-2">
            <span>{org.orgName}</span>
            <ChevronDown
              className={`h-4 w-4 transition-transform transform ${open ? "rotate-180" : "rotate-0"}`}
            />
          </SidebarGroupLabel>
        </CollapsibleTrigger>
        <CollapsibleContent asChild>
          <SidebarMenu>
            {links.filter((item) => item.adminFunction && org.role === "ADMIN" || !item.adminFunction).map((item) => (
              <SidebarMenuItem key={item.name}>
                <SidebarMenuButton asChild>
                  <a href={item.url}>
                    <item.icon />
                    <span>{item.name}</span>
                  </a>
                </SidebarMenuButton>
              </SidebarMenuItem>
            ))}
          </SidebarMenu>
        </CollapsibleContent>
      </SidebarGroup>
    </Collapsible>
  )
}

